export const getColorStyleCss = (colors: string) => {
  const colorCodes = colors.split(',');
  let colorStyle: Record<string, any>;

  if (colorCodes.length > 1) {
    colorStyle = {
      backgroundColor: colorCodes[0],
      backgroundImage: [
        `linear-gradient(to right, ${colorCodes.toString()}`,
        `-webkit-linear-gradient(to right, ${colorCodes.toString()}`,
        `-o-linear-gradient(to right, ${colorCodes.toString()}`,
      ],
    };
  } else {
    colorStyle = {
      backgroundColor: colorCodes[0],
    };
  }

  return colorStyle;
};
